import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { updateEmployee, refreshReferential } from '../../app/updateApp';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faSms } from '@fortawesome/pro-light-svg-icons';

const EmployeeGrid = () => {
    const { t } = useTranslation();
    useEffect(function () {
        refreshReferential().then(() => updateEmployee(employeeState.selectedEmployee));
    }, []);

    const employeeState = useSelector(state => state.employees);

    let currentEmploye = employeeState.team.find(empl =>
        empl.id === employeeState.selectedEmployee
    );
    if (!currentEmploye) {
        currentEmploye = employeeState.all.find(empl =>
            empl.id === employeeState.selectedEmployee
        );
    }

    return <div className='employee-grid'>
        {currentEmploye ? (
            <>
                <div className="section-title">
                    Nom <br /> <div className="section-value">{currentEmploye.lastname}</div>
                </div>
                <div className="section-title">Société <br /> <div className="section-value">{currentEmploye.entity?.rs || '-'}</div></div>
                <div className="section-title">Prénom <br />  <div className="section-value">{currentEmploye.firstname || '-'}</div></div>
                <div className="section-title">Fonction <br />  <div className="section-value">{currentEmploye.function || '-'}</div></div>
                <div className="section-title">Tél <div className="section-value">
                    {currentEmploye.phone ? (
                        <div className="phone-actions">
                            <div className="phone-icons tel">
                                <a href={`tel:${currentEmploye.phone}`} className="phone-action-link" title="Appeler">
                                    <FontAwesomeIcon icon={faPhone} />
                                </a>
                            </div>
                            <span className="phone-number">{currentEmploye.phone}</span>
                            <div className="phone-icons sms">
                                <a href={`sms:${currentEmploye.phone}`} className="phone-action-link" title="Envoyer un SMS">
                                    <FontAwesomeIcon icon={faSms} />
                                </a>
                            </div>
                        </div>
                    ) : '-'}
                </div></div>
                {/* <div className="section-title">Type<br /> <div className="section-value">{currentEmploye.employee_types.find(et => et.id === currentEmploye.employee_type_id)?.label || '-'}</div></div> */}
                {/* <div /> */}
                <div className="section-title">Date dʼentrée <br /> <div className="section-value">{moment(currentEmploye.start_date)?.format('DD MMMM YYYY') || '-'}</div></div>
            </>
        ) : null
        }
    </div>;
};

export default EmployeeGrid;